import { Edit2, Trash2 } from "lucide-react";

  const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];

export const initialVesselForm = {
        vessID: 0,
        vessel: "",
        carrierScac: "",
        carrier: "",
        imo: "",
        builtYear: "",
        flag: "",
        callSign: "",
        mmsi: "",
        createdBy: String(authUser?.id),
        modifyBy: String(authUser?.id),
        countryId: authUser?.companyId,   
       };

export const getVesselColumns = (handlers) => {
  const { handleEdit, handleDelete } = handlers;

  return [
    {
      key: "vessel",
      label: "VESSEL",
      render: (v) => v?.vessel || "-"
    },
    {
      key: "carrier",
      label: "CARRIER",
      render: (v) => v?.carrier || "-"
    },
    {
      key: "imo",
      label: "IMO CODE",
      render: (v) => v?.imo || "-"
    },
    {
      key: "callSign",
      label: "CALL SIGN",
      render: (v) => v?.callSign || "-"
    },
    {
      key: "flag",
      label: "FLAG",
      render: (v) => v?.flag || "-"
    },
    {
      key: "action",
      label: "ACTION",
      render: (v) => (
        <div className="flex items-center gap-3">
           <button
            onClick={() => handleEdit(v)}
                className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200 "
            title="Edit"
          >
            <Edit2 size={16} />
          </button>

          <button
            onClick={() => handleDelete(v)}
                        className="w-6 h-6 rounded flex items-center justify-center transition-all bg-red-100 text-red-700 hover:bg-red-200 "
            title="Delete"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )
    }
  ];
};